import React, { useRef } from 'react';
import { Formik } from "formik";
import { FormattedMessage } from "react-intl";
import { Button, TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Loadable, Container } from '../../../common'
import { PASSWORD_REGEX } from '../../../store/constants/pages';
import { toLocalStorage } from '../../../util/storage';
import { PasswordField } from '../../../common/PasswordField';
import { PasswordFieldHandle } from '../../../common/PasswordField/PasswordField';

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
    },
}));

export default function ForcedResetPasswordComponent(props) {
    const { intl, changePasswordPending, sessionConstructPending, actions: { sessionChangePassword } } = props;
    const classes = useStyles();
    const newPasswordRef = useRef<PasswordFieldHandle>(null);

    const handleCallback = () => {
        toLocalStorage("forceResetPW", null);
        props.history.push('/');
    }

    return (
        <Container>
            <Loadable loading={changePasswordPending || sessionConstructPending}>
                <div className="kt-login__head mb-0">
                    <div className="kt-login__title">
                        <h3>
                            {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
                            <FormattedMessage id="AUTH.INPUT.RESET_PASSWORD" />
                        </h3>
                    </div>
                </div>
                <Formik
                    initialValues={{
                        oldPassword: "",
                        newPassword: "",
                        confirmPassword: "",
                    }}
                    validate={values => {
                        const errors: any = {};

                        if (!values.oldPassword) {
                            errors.oldPassword = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        }

                        if (!values.newPassword) {
                            errors.newPassword = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (!values.newPassword.match(PASSWORD_REGEX)) {
                            errors.newPassword = intl.formatMessage({
                                id: "AUTH.VALIDATION.INVALID_PASSWORD"
                            });
                        }

                        if (!values.confirmPassword) {
                            errors.confirmPassword = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (values.newPassword !== values.confirmPassword) {
                            errors.confirmPassword =
                                "Password and Confirm Password didn't match.";
                        }

                        return errors;
                    }}
                    onSubmit={(values, { setStatus, setSubmitting }) => {
                        if (values.newPassword && !newPasswordRef.current?.isValid()) {
                            setSubmitting(false);
                            return;
                        }
                        sessionChangePassword(values.oldPassword?.trim(), values.newPassword?.trim(), handleCallback);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <form onSubmit={handleSubmit} noValidate autoComplete="off">
                            <div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <PasswordField 
                                            required={true}
                                            label="Old Password"
                                            name="oldPassword"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.oldPassword}
                                            helperText={touched.oldPassword && errors.oldPassword}
                                            error={Boolean(touched.oldPassword && errors.oldPassword)}
                                            showStrength={false}
                                        />
                                        <PasswordField 
                                            ref={newPasswordRef}
                                            required={true}
                                            label="New Password"
                                            name="newPassword"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.newPassword}
                                            helperText={touched.newPassword && errors.newPassword}
                                            error={Boolean(touched.newPassword && errors.newPassword) || Boolean(values.newPassword && !newPasswordRef.current?.isValid())}
                                            showStrength={true}
                                        />
                                        <PasswordField 
                                            required={true}
                                            label="Confirm Password"
                                            name="confirmPassword"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.confirmPassword}
                                            helperText={touched.confirmPassword && errors.confirmPassword}
                                            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                                            showStrength={false}
                                        />
                                    </div>
                                </div>
                                <div className='text-center pt-2'>
                                    {/* <Button
                                                component={Link}
                                                to="/dashboard"
                                                variant="contained"
                                                color="default"
                                                className={classes.button}>
                                                Cancel
                                            </Button> */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        type="submit"
                                        disabled={changePasswordPending}
                                    >
                                        Change Password
                                    </Button>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </Loadable>
        </Container>
    );
}